import { timestampDTOSchema } from '@tempo-io/common-dto';
import { z } from 'zod';

export const subscriptionDTOSchema = z.object({
  id: z.number(),
  monetizeNowId: z.string(),
  organizationId: z.string(),
  status: z.enum(['ACTIVE', 'CANCELLED', 'EXPIRED', 'SUSPENDED']),
  startDate: z.string(),
  endDate: z.string().nullable(),
  autoRenew: z.boolean(),
  ...timestampDTOSchema.shape,
});

export const subscriptionPageDTOSchema = z.object({
  data: z.array(subscriptionDTOSchema),
  total: z.number(),
});
